<template>
  <div class="monitoring-area-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group>
          <el-button @click="clickAdd" size="mini" type="primary"
                     icon="el-icon-plus">添加应急广播
          </el-button>
          <el-button @click="clickEdit" size="mini" type="primary"
                     icon="el-icon-edit">编辑应急广播
          </el-button>
          <el-button @click="del" size="mini" type="primary"
                     icon="el-icon-delete">删除应急广播
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="设备状态" property="id"></el-table-column>
        <el-table-column label="设备编号"></el-table-column>
        <el-table-column label="设备名称"></el-table-column>
        <el-table-column label="IP地址"></el-table-column>
        <el-table-column label="安装位置"></el-table-column>
        <el-table-column label="播放文件"></el-table-column>
        <el-table-column label="播放时长（秒）"></el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total"
                     @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="500px"
               :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">编号</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">设备名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">IP地址</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden upload">
          <span class="span">播放文件</span>
          <el-input size="mini" placeholder="点击上传文件" v-model="addobj.file" clearable></el-input>
          <input class="file" type="file" v-if="!addobj.file"/>
        </div>
        <div class="o-hidden">
          <span class="span">播放时长</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div>
          <span class="span">音量</span>
          <el-slider style="width:100%" :min="0" :max="100" v-model="addobj.value2"></el-slider>
        </div>
        <div class="o-hidden">
          <span class="span">所在场景</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择场景">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在区域</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择区域">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">安装地址</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">所在位置</span>
          <div class="div">
            <el-input class="input" placeholder="设置位置" size="mini" v-model="addobj.location"
                      clearable></el-input>
            <el-button class="btn ml-10" type="warning" size="mini">设置位置</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        fullscreenLoading: false,
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {
          name: "",
          value2: 10,
          select: "",
          file: "http://www.baidu.com/mp3.mp3",
          location: "12,34"
        },
        addDialogShow: false
      };
    },

    computed: {},

    created() {
      this.getData();
    },

    methods: {
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        setTimeout(() => {
          this.tableLoading = false;
          this.pagination.total = 222;
          this.list = [
            {id: 1},
            {id: 2},
            {id: 3},
            {id: 4},
            {id: 5},
            {id: 6},
            {id: 7},
            {id: 8},
            {id: 9},
            {id: 10}
          ];
        }, 10);
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-area-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .add-box {
      .upload {
        position: relative;
        .file {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
      .div {
        flex: 1;
        width: 0;
        display: flex;
        .input {
          flex: 1;
        }
        .btn {
          width: 80px;
        }
      }
    }
  }
</style>
